(() => {
  let inFlight = false;

  async function postBundleVariants(active, orderId) {
    for (const v of active) {
      const params = new URLSearchParams();
      params.set('id', String(v.variantId));
      params.set('quantity', String(v.quantity ?? 1));
      params.set('properties[_io_parent_order_group]', String(orderId));
      if (v.name) params.set('properties[_io_field_name]', String(v.name));
      await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: params.toString(),
      });
    }
  }

  async function handleClick(event) {
    if (inFlight) return;

    const btn = event.target.closest('.luggage-drop-product__atc');
    if (btn == null) return;

    const priceMod = window.Shoppad?.apps?.infiniteoptions?.priceMod;
    const active = priceMod?.activeVariants ? Object.values(priceMod.activeVariants) : [];
    if (active.length === 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    inFlight = true;

    const orderId = priceMod.orderId || String(Date.now());
    priceMod.orderId = orderId;

    try {
      await postBundleVariants(active, orderId);
    } catch (error) {
      console.warn('[ldrop-engraving-bundle] engraving POST failed:', error);
    }

    if (typeof priceMod.resetState === 'function') {
      priceMod.resetState();
    }

    const form = btn.closest('form');
    try {
      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit(btn);
      } else {
        btn.click();
      }
    } finally {
      inFlight = false;
    }
  }

  document.addEventListener('click', handleClick, true);
})();
